import { Col, DatePicker, Row } from "antd";
import React, { useEffect, useState } from "react";
import InputSearchBox from "../Input/InputSearchBox";
import { t } from "i18next";
import BaseButton from "../Button/BaseButton";
import { IconDownload, IconSuccess } from "../../../assets/icon";
import TblListReport from "../Table/TblListReport";
import SelectValue from "../Selector/SelectValue";
import { timeSelectSort } from "../../../utils/ValueSelect";
import TranslateText from "../TranslateText";
import { useDispatch } from "react-redux";
import { getListReport } from "../../../services/slice/SpamSlice";

const ListReport = () => {
  const [isSelectTime, setIsSelectTime] = useState(false);
  const dispatch = useDispatch();
  const [timeSelect, setTimeSelect] = useState({
    type: 0,
    timeStart: "",
    timeEnd: "",
  });
  const [config, setConfig] = useState({
    keySearch: "0",
    timeStart: "2024-10-02T10:43:01.539361",
    timeEnd: "2025-10-30T10:49:01.539361",
    typeScam: "-1",
    status: -1,
    option: {
      limit: 10,
      offset: 1,
      order: "asc",
    },
  });
  const dateFormat = "DD/MM/YYYY";
  const [valueSearch, setValueSearch] = useState();
  const valueOptionsRole = [
    {
      value: -1,
      label: "Tất cả",
    },
    {
      value: 0,
      label: "brand_name",
    },

    {
      value: 1,
      label: "data_spam_android",
    },
    {
      value: 2,
      label: "data_spam_iOS",
    },
  ];
  const valueSelectStatusDeals = [
    { value: -1, label: <TranslateText text={"Tất cả"} /> },
    { value: 1, label: <TranslateText text={"Chưa xử lý"} /> },
    { value: 2, label: <TranslateText text={"Số điện thoại lừa đảo"} /> },
    { value: 3, label: <TranslateText text={"Số điện thoại làm phiền"} /> },
    {
      value: 4,
      label: <TranslateText text={"Số điện thoại lừa đảo, làm phiền"} />,
    },
    { value: 5, label: <TranslateText text={"Số điện thoại chưa xác định"} /> },
  ];
  useEffect(() => {
    dispatch(getListReport(config));
  }, [config, dispatch]);
  return (
    <div>
      <Row
        style={{ width: "100%" }}
        className="headerPage"
        // justify={"space-between"}
      >
        <Col>
          <h2 className="title">{t("Danh sách gửi phản ánh")}</h2>
        </Col>
        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            icon={
              <IconDownload
                width={16}
                height={14}
                style={{ marginRight: "0.5rem" }}
              />
            }
            content={`Excel`}
            width={120}
            typeBtn="btnOrange"
          />
        </Col>
      </Row>
      <Row style={{ width: "100%" }} gutter={20} justify={"space-between"}>
        <Col className="" style={{ padding: "unset" }} span={3}>
          <InputSearchBox
            setText={(value) => {
              setValueSearch(value);
            }}
            placeholder={"Tìm kiếm"}
          />
        </Col>
        <Col
          span={isSelectTime ? 9 : 6}
          // className="border"
          style={{
            flexGrow: "1",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <span
            style={{
              marginRight: "1rem",
              fontWeight: "400",
              color: "rgba(0, 0, 0, 1)",
            }}
          >
            Thời gian
          </span>
          <SelectValue
            width={isSelectTime ? 125 : 185}
            handleChange={(value) => {
              if (value !== 0) {
                const timeStart = "";
                const timeEnd = "";
                // if(value)
                setIsSelectTime(false);
                // setConfig({ ...config, typeTime: value });
              } else {
                setIsSelectTime(true);
              }
            }}
            defaultValue={timeSelectSort[0].label}
            type={"selectGray mr-3"}
            optionsValue={timeSelectSort}
          />
          {isSelectTime ? (
            <>
              <span
                style={{
                  marginRight: "1rem",
                  fontWeight: "400",
                  color: "rgba(0, 0, 0, 1)",
                }}
              >
                Từ
              </span>
              <DatePicker
                // defaultValue={dayjs("2015/01/01", dateFormat)}
                onChange={(value) => {
                  if (value) {
                    setTimeSelect({
                      ...timeSelect,
                      timeStart: value.format("YYYY-MM-DD 00:00:00"),
                    });
                  } else {
                    setTimeSelect({
                      ...timeSelect,
                      timeStart: "",
                    });
                  }
                }}
                style={{
                  borderRadius: "33px",
                  width: "120px",
                  background: "rgba(240, 240, 240, 1)",
                  color: "rgba(130, 130, 130, 1)",
                  height: "34px",
                }}
                format={dateFormat}
                className="mr-3"
              />
              <span
                style={{
                  marginRight: "1rem",
                  fontWeight: "400",
                  color: "rgba(0, 0, 0, 1)",
                }}
              >
                đến
              </span>
              <DatePicker
                // defaultValue={dayjs("2015/01/01", dateFormat)}

                style={{
                  width: "120px",
                  borderRadius: "33px",
                  background: "rgba(240, 240, 240, 1)",
                  color: "rgba(130, 130, 130, 1)",
                  height: "34px",
                }}
                format={dateFormat}
                onChange={(value) => {
                  if (value) {
                    setTimeSelect({
                      ...timeSelect,
                      timeEnd: value.format("YYYY-MM-DD 23:59:59"),
                    });
                  } else {
                    setTimeSelect({
                      ...timeSelect,
                      timeEnd: "",
                    });
                  }
                  // setConfig({
                  //   ...config,
                  //   ...timeSelect,
                  //   typeTime: 0,
                  //   timeEnd: value.format("YYYY-MM-DD 23:59:59"),
                  // });
                }}
              />
            </>
          ) : null}
        </Col>
        <Col className="">
          <span className="mr-5">Phân loại</span>
          <SelectValue
            type={"selectGray"}
            optionsValue={valueOptionsRole}
            width={170}
            defaultValue={"Tất cả"}
            handleChange={(value) => {}}
            key="selectFileSpam"
          />
        </Col>
        <Col className="">
          <span
            style={{
              marginRight: "1rem",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            Trạng thái
          </span>
          <SelectValue
            width={200}
            // handleChange={(value) => dispatch(setStatusDeals(value))}
            optionsValue={valueSelectStatusDeals}
            defaultValue="Tất cả"
            type={"selectGray"}
          />
        </Col>
        <Col
          className=""
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            cursor: "pointer",
          }}
          span={1}
        >
          <IconSuccess width={20} height={20} fill="rgba(4, 125, 231, 1)" />
        </Col>
      </Row>
      <TblListReport />
    </div>
  );
};

export default ListReport;
